import { ItemList } from "../orm";
import { parseISO, format } from "date-fns";

class PurchasedTrolleyList extends ItemList {
  getEntityKey() {
    return "customer/purchased_trolley";
  }
}

export const purchasedTrolleyList = new PurchasedTrolleyList(
  "purchased_trolley_default",
);

class PurchasedTrolleyPhotographsList extends ItemList {
  getEntityKey() {
    return "customer/purchased_trolley/photographs";
  }

  getPhotos({purchased_trolley_id}) {
    return this.saveNewObject({
      purchased_trolley_id: purchased_trolley_id,
    })
  }
}

export const purchasedTrolleyPhotographsList = new PurchasedTrolleyPhotographsList(
  "purchased_trolley_photographs_default",
);

export const formatCurrency = (amount) => {
  if (amount == null) return "";
  return `$${Number(amount).toFixed(2)}`;
};

export const formatDate = (date) => {
  if (date == null) return "";
  return format(parseISO(date), "dd MMMM yyyy")
}
